import React, { useState, useRef, useEffect } from "react";
import dayjs from "dayjs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import {
  ACTIONS,
  ACTIVITY_STATUS,
  FILTERS,
  STATUS_MAPPING,
} from "../../../common/Constants";
import { useGetAllVendorActivities } from "../../../../backend/query";
import {
  ACTIVITY_TYPE,
  ACTIVITY_TYPE_ICONS,
  API_DELIMITER,
  API_RESULT,
  ERROR_MESSAGES,
} from "../../../../utils/constants";
import Table, {
  CellTmpl,
  DEFAULT_PAYLOAD,
  TitleTmpl,
  reactFormatter,
} from "../../../common/Table";
import AdvanceSearch from "../../../common/AdvanceSearch";
import { preventDefault } from "../../../../utils/common";
import AlertModal from "../../../common/AlertModal";
import PageLoader from "../../../shared/PageLoader";
import Icon from "../../../common/Icon";
import AdminLocations from "./AdminVendorScheduleLocation";
import ConfirmModal from "../../../common/ConfirmModal";
import { useDeleteVendorAuditSchedule } from "../../../../backend/masters";
import { toast } from "react-toastify";
import { hasUserAccess } from "../../../../backend/auth";
import { USER_PRIVILEGES } from "../../UserManagement/Roles/RoleConfiguration";
import { GetVendorAuditScheduleBreadcrumb } from "./Companies.constants";
import MastersLayout from "../MastersLayout";
import { AxiosError } from "axios";

const SortFields: any = {
  "act.name": "act_name",
  "rule.name": "rule_name",
  "activity.name": "activity_activity_name",
  "associate_company.name": "associate_company_name",
  "location.name": "location_name",
  "activity.activity_type": "activity_activity_type"
};

const INCLUDE_ASSOCIATION_COLUMNS = {
  act: { only: ['name'] },
  rule: { only: ['name'] },
  activity: { only: ['name', 'activity_type'] },
  associate_company: { only: ['name'] },
  location: { only: ['name'] }
};

const INCLUDES_ASSOCIATIONS = ['act', 'rule', 'activity', 'associate_company', 'location'];

function VendorAuditScheduleDetails(this: any) {
  const [breadcrumb] = useState(
    GetVendorAuditScheduleBreadcrumb("Audit Schedule Details")
  );
  const [activity, setActivity] = useState<any>();
  const [action, setAction] = useState(ACTIONS.NONE);
  const [data, setData] = useState<any>();
  const [params, setParams] = useState<any>();
  const [locationFilters, setLocationFilter] = useState<any>();
  const lfRef: any = useRef();
  lfRef.current = locationFilters;
  const [advaceSearchFilters, setAdvanceSearchFilters] = useState<any>();
  const afRef: any = useRef();
  afRef.current = advaceSearchFilters;
  const [statusFilters] = useState({ status_in: [ACTIVITY_STATUS.PENDING, ACTIVITY_STATUS.OVERDUE]});
  const sfRef: any = useRef();
  sfRef.current = statusFilters;
  const [payload, setPayload] = useState<any>();
  const payloadRef: any = useRef();
  payloadRef.current = payload;
  const { activities, total, isFetching, refetch } = useGetAllVendorActivities(
    payload,
    Boolean(hasFilters(null, "company_id_eq"))
  );

  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [alertMessage, setAlertMessage] = useState<any>(null);
  const [deleteVendorAuditRequests, setDeleteVendorAuditRequests] = useState<any[]>([]);
    const [deleteCount, setDeleteCount] = useState<number>(0);
    const [vendorAuditDeleting, setVendorAuditDeleting] = useState<boolean>(false);
    const [delectingAction, setDeletingAction] = useState(ACTIONS.NONE);
  const { deleteAuditSchedule, deleting } = useDeleteVendorAuditSchedule(
    (response: any) => {
      if (response instanceof AxiosError){
          const data = (response.response || {}).data;
          const error = (data || {}).error || ERROR_MESSAGES.DEFAULT;
          toast.error(error);
      } else {
          if(delectingAction == ACTIONS.BULK_DELETE){
              setDeleteCount(deleteCount + 1);
          } else if(delectingAction == ACTIONS.DELETE) {
              toast.success(`${selectedRows.length > 1 ? "Activities" : "Activity"} deleted successfully.`);
              setVendorAuditDeleting(false);
              setDeleteCount(0);
              setDeleteVendorAuditRequests([]);
              setDeletingAction(ACTIONS.NONE);
              dismissAction();
              refetch();
          }
      }
    }
  );

  useEffect(() => {
      if (delectingAction == ACTIONS.BULK_DELETE && deleteCount != selectedRows.length) {
          const tempRequests = [...deleteVendorAuditRequests];
          const id = tempRequests.shift();
          setDeleteVendorAuditRequests(tempRequests);
          deleteAuditSchedule({id});
      } else if (delectingAction == ACTIONS.BULK_DELETE && deleteCount === selectedRows.length) {
          toast.success(`${selectedRows.length > 1 ? "Activities" : "Activity"} deleted successfully.`);
          setVendorAuditDeleting(false);
          setDeleteCount(0);
          setDeleteVendorAuditRequests([]);
          setDeletingAction(ACTIONS.NONE);
          dismissAction();
          refetch();
      }
  }, [deleteCount]);

  function hasFilters(ref: any, field = "company_id") {
    const tempPayloadRef = { ...(payloadRef.current || {}) };
    const _filters = (ref ? ref.current : tempPayloadRef.filters) || [];
    const company_id = _filters[field];
    return company_id || "";
  }

  function onLocationChange(event: any) {
    const {
      company,
      associate_company,
      location_id,
      vendor_category_id,
      vendor_registration_id,
    } = event;
    setLocationFilter({
        company_id_eq: company,
        associate_company_id_eq: associate_company,
        location_id_eq: location_id,
        vendor_category_id_eq: vendor_category_id || "",
        vendor_registration_id_eq: vendor_registration_id || "",
    });
  }

  
  function onLocation2Change(event: any) {
    const {
      company,
      associate_company,
      location_id,
      vendorCategoriesId,
      vendorRegistrationId,
    } = event;
    setLocationFilter([
      {
        columnName: "company_id",
        value: company,
      },
      {
        columnName: "associate_company_id",
        value: associate_company,
      },
      {
        columnName: "location_id",
        value: location_id,
      },
      {
        columnName: "vendorCategoriesId",
        value: vendorCategoriesId,
      },
      {
        columnName: "vendorRegistrationId",
        value: vendorRegistrationId,
      },
    ]);
  }

  function search(event: any) {
    const _filters: any = {};
    const keys = Object.keys(event || {});
    if (keys.length > 0) {
        keys.forEach(key => {
            _filters[key] = event[key]
        });
    }
    setAdvanceSearchFilters(_filters);
  }

  function dismissAction() {
    setAction(ACTIONS.NONE);
    setActivity(null);
  }

  function MonthTmpl({ cell }: any) {
    const row = cell.getData();
    return (
      <>
        {row.month} ({row.year})
      </>
    );
  }

  function DueDateTmpl({ cell }: any) {
    const value = cell.getValue();
    return (
      <span className="text-warn">{dayjs(value).format("DD-MM-YYYY")}</span>
    );
  }

  function FormStatusTmpl({ cell }: any) {
    const status = cell.getValue();
    return (
      <div className="d-flex align-items-center position-relative">
        <span className={`status-${status} ellipse`}>
          {STATUS_MAPPING[status] || status}
        </span>
      </div>
    );
  }

  function ActionColumnElements({ cell }: any) {
    const row = cell.getData();

    return (
      <div className="d-flex flex-row align-items-center position-relative">
        {hasUserAccess(USER_PRIVILEGES.DELETE_AUDIT_SCHEDULE_DETAILS) && (
          <Icon
            className="mx-1"
            type="button"
            name="trash"
            text="Delete"
            data={row}
            action={handleDelete}
          />
        )}
      </div>
    );
  }

  function ActivityTypeTmpl({ cell }: any) {
    const value = cell.getValue() || ACTIVITY_TYPE.AUDIT;
    return (
      <div className="d-flex flex-row align-items-center justify-content-center position-relative">
        <Icon name={ACTIVITY_TYPE_ICONS[value]} text={value} />
      </div>
    );
  }

  const columns = [
    {
      title: "",
      field: "auditted",
      width: 40,
      formatter: reactFormatter(<ActivityTypeTmpl />),
    },
    {
      title: "Month & Year",
      field: "month",
      width: 140,
      formatter: reactFormatter(<MonthTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
    },
    {
      title: "Act",
      field: "act.name",
      widthGrow: 2,
      formatter: reactFormatter(<CellTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
    },
    {
      title: "Rule",
      field: "rule.name",
      widthGrow: 2,
      formatter: reactFormatter(<CellTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
    },
    {
      title: "Activity",
      field: "activity.name",
      formatter: reactFormatter(<CellTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
      widthGrow: 2,
    },
    {
      title: "Activity Type",
      field: "activity.activity_type",
      formatter: reactFormatter(<CellTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
    },
    {
      title: "Associate Company",
      field: "associate_company.name",
      formatter: reactFormatter(<CellTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
      widthGrow: 1,
    },
    {
      title: "Location Name",
      field: "location.name",
      formatter: reactFormatter(<CellTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
      widthGrow: 1,
    },
    {
      title: "Audit Due Date",
      field: "due_date",
      width: 120,
      formatter: reactFormatter(<DueDateTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
    },
    {
      title: "Forms Status",
      field: "status",
      width: 160,
      formatter: reactFormatter(<FormStatusTmpl />),
      titleFormatter: reactFormatter(<TitleTmpl />),
    },
    {
      title: "Actions",
      hozAlign: "center",
      width: 120,
      headerSort: false,
      formatter: reactFormatter(<ActionColumnElements />),
      titleFormatter: reactFormatter(<TitleTmpl />),
      visible: hasUserAccess(USER_PRIVILEGES.DELETE_AUDIT_SCHEDULE_DETAILS),
    },
  ];

  const [tableConfig] = useState({
    paginationMode: "remote",
    ajaxRequestFunc,
    columns,
    rowHeight: "auto",
    selectable: true,
    paginate: true,
    initialSort: ['month desc'],
  });

  function formatApiResponse(params: any, list: any[], totalRecords: number) {
    const { page, per } = params || {};
    const tdata = {
      data: list,
      total: totalRecords,
      last_page: Math.ceil(totalRecords / (per || 1)) || 1,
      page: page || 1,
    };
    setData(tdata);
    return tdata;
  }

  function ajaxRequestFunc(url: any, config: any, params: any) {
    const { field, dir } = (params.sort || [])[0] || {};
    const _params = {
      page: params.page,
      per: params.size,
      sorts: [`${SortFields[field] || field || 'month'} ${dir || 'desc'}`],
      includes: INCLUDES_ASSOCIATIONS,
      include: INCLUDE_ASSOCIATION_COLUMNS
    };
    setParams(_params);
    setPayload({
      ...DEFAULT_PAYLOAD,
      ..._params,
      filters: {
        ...(lfRef.current || {}),
        ...(afRef.current || {}),
        ...(sfRef.current || {}),
      }
    });
    return Promise.resolve(formatApiResponse(params, activities, total));
  }

  function handlePageNav(_pagination: any) {
    const _params = { ..._pagination };
    setParams({ ..._params });
    setPayload({ ...payload, ..._params });
  }

  function getAdvanceSearchPayload() {
    const _filters = {...(afRef.current || {})};
    return _filters;
  }

  function handleDelete(_activity: any) {
    setActivity(_activity);
    setAction(ACTIONS.DELETE);
    setDeletingAction(ACTIONS.DELETE);
  }

  function performDelete() {
    setVendorAuditDeleting(true);
    deleteAuditSchedule({id: activity.id});
  }
  function performBulkDelete() {
    const requests = selectedRows.map((x: any) => x.id);
    const id = requests.shift();
    setDeleteVendorAuditRequests(requests);
    setVendorAuditDeleting(true);
    deleteAuditSchedule({id});
  }

  function handleBulkDelete(e: any) {
    preventDefault(e);
    if ((selectedRows || []).length > 0) {
      setAction(ACTIONS.BULK_DELETE);
      setDeletingAction(ACTIONS.BULK_DELETE);
    }
  }

  function onSelectionChange(_selectedRows: any) {
    setSelectedRows(_selectedRows);
  }

  useEffect(() => {
    if (locationFilters) {
      setPayload({
        ...payload,
        ...DEFAULT_PAYLOAD,
        sorts: ['month desc'],
        ...params,
        filters: {
          ...locationFilters,
          ...(afRef.current || {}),
          ...(sfRef.current || {}),
        }
      });
    }
  }, [locationFilters]);

  useEffect(() => {
    if (advaceSearchFilters) {
      setPayload({
        ...payload,
        ...DEFAULT_PAYLOAD,
        sorts: ['month desc'],
        ...params,
        filters: {
          ...(lfRef.current || {}),
          ...advaceSearchFilters,
          ...(sfRef.current || {}),
        }
      });
    }
  }, [advaceSearchFilters]);

  useEffect(() => {
    if (!isFetching && payload) {
      setSelectedRows([]);
      setData(formatApiResponse(params, activities, total));
    }
  }, [isFetching]);

  return (
    <>
      <MastersLayout
        title="Vendor Audit Schedule Details"
        breadcrumbs={breadcrumb}
      >
        <form className="p-0 mx-3 my-2">
          <div className="card shadow border-0 p-2 mt-2 mb-3 filters">
            <div className="d-flex flex-row m-0 align-items-end">
              <AdminLocations onChange={onLocationChange} />
              <div>
                <AdvanceSearch
                  fields={[
                    FILTERS.MONTH,
                    FILTERS.SUBMITTED_DATE,
                    FILTERS.ACTIVITY_TYPE,
                  ]}
                  payload={getAdvanceSearchPayload()}
                  onSubmit={search}
                />
              </div>
              <div className="ms-auto">
                {hasUserAccess(
                  USER_PRIVILEGES.DELETE_AUDIT_SCHEDULE_DETAILS
                ) && (
                  <button
                    className="btn btn-danger"
                    onClick={handleBulkDelete}
                    disabled={!(selectedRows || []).length}
                  >
                    <div className="d-flex align-items-center">
                      <FontAwesomeIcon icon={faTrash} />
                      <span className="ms-2 text-nowrap">Bulk Delete</span>
                    </div>
                  </button>
                )}
              </div>
            </div>
          </div>
        </form>
        <Table
          data={data}
          options={tableConfig}
          isLoading={isFetching}
          onSelectionChange={onSelectionChange.bind(this)}
          onPageNav={handlePageNav}
        />
      </MastersLayout>
      {!!alertMessage && (
        <AlertModal
          message={alertMessage}
          onClose={(e: any) => {
            preventDefault(e);
            setAlertMessage(null);
          }}
        />
      )}
      {action === ACTIONS.DELETE && (
        <ConfirmModal
          title={"Delete Activity"}
          onSubmit={performDelete}
          onClose={() => setAction(ACTIONS.NONE)}
        >
          <div className="text-center mb-4">
            Are you sure you want to delete the activity ?
          </div>
        </ConfirmModal>
      )}
      {action === ACTIONS.BULK_DELETE && (
        <ConfirmModal
          title={"Delete Activities"}
          onSubmit={performBulkDelete}
          onClose={() => setAction(ACTIONS.NONE)}
        >
          <p className="text-center mb-4">
            There are {selectedRows.length} record(s) selected for deleting.
          </p>
          <div className="text-center mb-4">
            Are you sure you want to delete all of them ?
          </div>
        </ConfirmModal>
      )}
      {vendorAuditDeleting && <PageLoader message={delectingAction === ACTIONS.BULK_DELETE ? `Deleting ${deleteCount + 1} of ${selectedRows.length}` : 'Deleting...'} />}
    </>
  );
}

export default VendorAuditScheduleDetails;
